import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { TOASTER_ID_KEYS } from "@/constants";
import { AppShellProvider } from "@/features/dashboard/_context/appShellContext";

export const Route = createFileRoute("/_private")({
  component: () => (
    <AppShellProvider>
      <Outlet />,
    </AppShellProvider>
  ),
  beforeLoad: ({ context }) => {
    const {
      store,
      libs: { toast }
    } = context;

    const state = store.getState();

    if (!state.auth.isAuthenticated) {
      toast.error("Você precisa estar logado para acessar esta página.", {
        toasterId: TOASTER_ID_KEYS.AUTH.LOGIN_REDIRECT
      });
      throw redirect({ to: "/login" });
    }
  }
});
